import {
  ChatBubbleLeftRightIcon,
  Cog6ToothIcon,
  CreditCardIcon,
  ShoppingBagIcon,
  UserCircleIcon
} from '@heroicons/vue/24/outline'
import { markRaw } from 'vue'

import { MEMBERSHIP_FEATURE } from '@/config/membershipTierView'

export const CUSTOMER_TABS = [
  { key: 'messages', label: 'Messages', icon: markRaw(ChatBubbleLeftRightIcon), path: null, permissions: [] },
  {
    key: 'profile',
    label: 'Profile',
    icon: markRaw(UserCircleIcon),
    path: '',
    permissions: [['customer_profile', 'read']]
  },
  {
    key: 'orders',
    label: 'Orders',
    icon: markRaw(ShoppingBagIcon),
    path: 'orders',
    permissions: [
      ['customer_profile', 'read'],
      ['orders', 'read']
    ]
  },
  {
    key: 'membership',
    label: 'Membership',
    icon: markRaw(CreditCardIcon),
    path: 'membership',
    permissions: [['customer_profile', 'read']],
    feature: MEMBERSHIP_FEATURE
  },
  {
    key: 'settings',
    label: 'Settings',
    icon: markRaw(Cog6ToothIcon),
    path: 'settings',
    permissions: [['customer_profile', 'read']]
  }
]

// A tab with a plan feature shows only while the plan includes it (BOT-1793:
// every membership endpoint is gated on it).
export function visibleCustomerTabs(can, on = () => true) {
  return CUSTOMER_TABS.filter(
    tab => (!tab.feature || on(tab.feature)) && tab.permissions.every(([resource, action]) => can(resource, action))
  )
}

export function customerTabPath(tab, { id, listId }) {
  if (tab.key === 'messages') return `/messages/${id}`
  const base = listId ? `/lists/${listId}/profile/${id}` : `/profile/${id}`
  return tab.path ? `${base}/${tab.path}` : base
}

export function customerTabRoutes(components) {
  return CUSTOMER_TABS.filter(tab => tab.key !== 'messages' && components[tab.key]).map(tab => ({
    path: tab.path,
    meta: { title: tab.label, customerTab: tab.key },
    component: components[tab.key]
  }))
}

export const REVENUE_REPORT_VIEW = 'revenue'

export function customerProfilePath({ id, listId }) {
  return customerTabPath(
    CUSTOMER_TABS.find(tab => tab.key === 'profile'),
    { id, listId }
  )
}

export function customerRevenueReportPath({ id, listId }) {
  return `${customerProfilePath({ id, listId })}/${REVENUE_REPORT_VIEW}`
}

export function customerRevenueRoute(component) {
  return {
    path: REVENUE_REPORT_VIEW,
    meta: { title: 'Revenue', customerTab: 'profile', customerView: REVENUE_REPORT_VIEW },
    component
  }
}
